<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-6 login-section-wrapper">
        <div class="brand-wrapper">
          <img
            src="@/assets/images/brand/logo.png"
            alt="Findus logo"
            class="logo"
          />
        </div>
        <div class="login-wrapper my-auto">
          <h1 class="login-title">Password Dimenticata</h1>
          <form action="#!">
            <div class="form-group mb-4">
              <label for="email">Email</label>
              <input
                type="email"
                name="email"
                id="email"
                class="form-control"
                placeholder="email@example.com"
                v-model.trim="$v.email.$model"
              />
            </div>

            <LoadingButton
              :text="'Invia Email'"
              :classes="['btn', 'btn-block', 'login-btn', 'w-100']"
              :loading="loading"
              :disabled="$v.$invalid"
              @click="resetPassword()"
            />
          </form>
        </div>
      </div>
      <div class="col-sm-6 px-0 d-none d-sm-block">
        <img
          :src="image"
          alt="login image"
          class="login-img"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { email, required } from "vuelidate/lib/validators";
import AuthService from "@/services/auth";

export default {
  data() {
    return {
      email: "",
      error: "",
      loading: false,
      image: '/static/images/login/findus_01.jpg'
    };
  },
  validations: {
    email: {
      email,
      required,
    },
  },
  methods: {
    getImage() {
      const images = [
        '/static/images/login/findus_01.jpg',
        '/static/images/login/findus_02.jpg',
        '/static/images/login/findus_03.jpg',
        '/static/images/login/findus_04.jpg',
        '/static/images/login/findus_05.jpg',
        '/static/images/login/findus_06.jpg',
        '/static/images/login/findus_07.jpg',
        '/static/images/login/findus_08.jpg',
        '/static/images/login/findus_09.jpg'
      ];

      this.image = images[Math.floor(Math.random() * images.length)];
    },
    async resetPassword() {
      this.loading = true;

      try {
        await AuthService.forgotPassword(this.email);

        this.$toast.success("Controlla la tua casella e-mail per reimpostare la password!");
        this.$router.push({ name: "LoginPage" });
      } catch (error) {
          this.$toast.error(error.message);
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.getImage();
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/pages/login";
</style>



// WEBPACK FOOTER //
// src/pages/auth/forgot-password/ForgotPasswordPage.vue